(function($,w){$(function(){

    class dfbmBlogthread
    {

        setProperties()
        {

            this.state  = {};

            this.noURL  = false;

            this.posts  = false;

            this.headH  = this.header();

            this.width  = $( w ).width();

            this.navBar = $( '#dfbm-cat-nav' );

            this.active = $( '#dfbm-active-cat' );

            this.parent = $( '#dfbm-container' );

            this.feat   = this.parent.children( 'div.et_pb_featured_posts' );

            this.blog   = this.parent.children( 'div.filterable-blogposts' );

            this.grid   = this.parent.hasClass( 'grid' ) ? true : false;

            this.full   = this.parent.hasClass( 'full' ) ? true : false;

            this.cCol   = parseInt( dfbmPhp.cMax );

            this.cWid   = parseInt( dfbmPhp.cWidth );

            this.cDist  = parseInt( dfbmPhp.cDist );

            this.mWid   = this.cWid / this.cCol;

            this.lBase  = dfbmPhp.lBase;

            this.lStart = this.lBase;

            this.lCurr  = this.lBase;

            this.lAjax  = this.lBase;

            this.nonce  = dfbmPhp.nonce;

            this.url    = dfbmPhp.url;

            this.body   = $( 'body' );

            this.shop   = this.body.hasClass( 'woocommerce' ) ? true : false;

            this.search = this.body.hasClass( 'search' ) ? true : false;

            this.author = this.body.hasClass( 'author' ) ? true : false;

            this.lb     = 'on' == dfbmPhp.ltBox ? true : false;

        } // end setProperties

        constructor()
        {

            this.setProperties();

            this.bindEvents();

            this.initialize();

        } // end constructor

        initialize( self = this )
        {

            let img,
                obj = self.getHistoryObj();

            self.removeSession( 'dfbmLoaded' );

            if ( obj && null != obj.state.addMore && ! ( self.getSession( 'dfbmRedirect' ) && obj.curr != obj.base ) )
                self.setSession( 'dfbmAddMore', true );

            if ( self.getSession( 'dfbmRedirect' ) && ! self.getSession( 'dfbmAddMore' ) )
                self.blog.children( 'article' ).addClass( 'redirect' );

            if ( ! obj )
                self.posts = self.normalizePosts( self.blog.children( 'article' ) );

            img = self.imagesToLoad( self.posts ? self.posts : obj.state.content.posts );

            self.interval( img, self.inCallback, self );

        } // end initialize

        masonry()
        {

            this.blog.mosaicflow(
            {

                columnClass  : 'article-col',
                itemSelector : 'article',
                minItemWidth : this.cWid / this.cCol,
                itemHeightCalculation: 'auto',
                minColumns   : 1,

            });
        } // end masonry

        featured( self = this )
        {

            let img = self.feat.find( 'img' );

            self.interval( img, self.featCallback, self );

        } // end featured

        fullwidth( toFix = false, self = this )
        {

            let innFull = self.blog.children( 'article' ),
                width   = innFull.width();

            innFull.each( function()
            {

                let childs = $(this).children().children();

                if ( childs.length < 2 )
                    childs.css( 'width', '100%' );

                else
                {

                    let cont    = $(this).find( 'div.et_pb_content_container' ),
                        min     = self.width > 767 ? 400 : 350,
                        cHeight = cont.css( 'minHeight', min ).outerHeight();

                    if ( $(this).hasClass( 'format-gallery' ) )
                        self.initGallery( $(this).find( 'div.et_pb_slider' ) );

                    if ( self.width > 767 )
                    {

                        $(this).children().css( 'maxHeight', cHeight );

                        self.getElements(
                            $(this) ).css(
                            {

                                'height'   : cHeight,
                                'width'    : width * 0.6,
                                'maxWidth' : width * 0.6,

                            }
                        );

                    }

                    else
                    {

                        $(this).children().removeAttr( 'style' );

                        self.getElements( $(this) ).removeAttr( 'style' );

                    }
                }
            });
        } // end fullwidth

        videoWidth( resize = false, self = this )
        {

            if ( self.getSession( 'dfbmLoaded' ) )
                return;

            self.setSession( 'dfbmLoaded', true );

            let c, width, column, video;

            if ( ! resize )
            {

                width   = self.blog.outerWidth(),
                column  = ( c = Math.floor( width / self.mWid ) ) > self.cCol ? self.cCol : ( self.width > 767 && c < 2 ? 2 : c ),
                video   = ( width / column ) - self.cDist;

            }

            else
            {

                video = self.blog.children( 'div.article-col' ).first().width();

            }

            if ( ! self.blog.children( 'div' ).hasClass( 'no-posts' ) )
            {

                self.blog.children( 'article.format-video' ).each( function()
                {

                    let css  = { 'width' : video, height : video / ( 16 / 9 ) },
                        cont = $(this).find( 'div.et_main_video_container' ),
                        item = cont.children( 'div.wp-video' );

                    if ( item.length > 0 )
                    {

                        item.css( css );

                        item.find( 'video.wp-video-shortcode' ).css( css );

                    }

                    else
                        cont.find( 'iframe' ).css( css );

                }).promise().done( function()
                {

                    return self.masonry();

                });
            }

            else
                self.blog.trigger( 'blogs-loaded' );

        } // end videoWidth

        header()
        {

            let h,
                header = ! isNaN( h = parseInt( dfbmPhp.header ) )
                         ? h
                         : ( ! $( 'body' ).hasClass( 'et_vertical_nav' )
                             && $( '#main-header' ).length > 0
                             && this.width > 980
                             ? $( '#main-header' ).outerHeight()
                             : 0 );

            if ( h && this.width < 981 )
                header = parseInt( dfbmPhp.mobile );

            return header;

        } // end header

        catNavSubmenu()
        {

            let width = ( $( w ).width() / 2 ),
                list  = this.navBar.find( 'ul.dfbm-sub-menu.first' );

            list.each( function()
            {

                if ( width < $(this).parent().offset().left )
                {

                    if ( $(this).hasClass( 'left') )
                        $(this).addClass( 'right' ).removeClass( 'left' );

                }

                else
                {

                    if ( $(this).hasClass( 'right') )
                        $(this).addClass( 'left' ).removeClass( 'right' );

                }

            });

        } // end catNavSubmenu

        catNavAddParent()
        {

            let list = this.navBar.find( 'ul.dfbm-sub-menu.first' );

            list.parent().addClass( 'parent' );

        } // end catNavAddParent

        catNavPadding()
        {

            if ( this.width < 768 && this.navBar.parent().hasClass( 'text' ) )
            {

                this.navBar.find( 'ul.dfbm-sub-menu.first' )
                    .css( 'paddingTop', this.navBar.height() - 20 );

            }

        } // end 1

        minHeight()
        {

            let header = this.width > 980 ? this.headH : 0;

            return $( w ).outerHeight()
                   - header
                   - this.navBar.parent().outerHeight()
                   - $( '#dfbm_blog_pagination' ).outerHeight()
                   - $('#main-footer').outerHeight()
                   + 15;

        } // end minHeight

        getElements( $art )
        {

            if ( $art.hasClass( 'format-gallery' ) )
                return $art.find( 'div.et_pb_slider, div.et_pb_slides' );

            if ( $art.hasClass( 'format-video' ) )
                return $art.find( 'div.et_pb_video_overlay, div.et_main_video_container, div.wp-video, .wp-video-shortcode, div.fluid-width-video-wrapper, iframe' );

            if ( $art.hasClass( 'format-quote' ) )
                return $art.find( 'div.et_quote_content' );

            if ( $art.hasClass( 'format-audio' ) )
                return $art.find( 'div.et_audio_content' );

            if ( $art.hasClass( 'format-link' ) )
                return $art.find( 'div.et_link_content' );

            return $art.find( 'img' );

        } // end getElements

        imagesToLoad( $arr )
        {

            let $i = 0, images = [], img;

            $( $arr ).each( function()
            {

                if ( $(this).hasClass( 'format-standard' ) || $(this).hasClass( 'type-product' ) )
                    img = $(this).find( 'img' );

                if ( $(this).hasClass( 'format-video' ) )
                {
                    let ovlay = $(this)
                            .find( 'div.et_main_video_container' )
                            .children( 'div.et_pb_video_overlay' ),
                        url   = ovlay.css('background-image');

                    if ( url )
                    {

                            url = url.trim().replace( /(url\(|\)|'|")/gi, '' );

                        img = $('<img />', { src: url, } );

                        }

                        else
                            img = $(this).find( 'img' );
                }

                if ( img && img.length > 0 )
                {

                    images[$i] = img[0];

                    $i++;

                }
            });

            return images;

        } // end imagesToLoad

        interval( $img, callback, self = this )
        {

            let int = setInterval( () =>
            {

                if ( $img.length < 1 || self.imagesLoaded( $img ) )
                {

                    clearInterval( int );

                    return callback( self );

                }

            }, 100 );

        } // end interval

        inCallback( self = this )
        {

            if ( self.width > 767 )
            {

                if ( self.feat )
                    self.featured();

                if ( self.full )
                    self.fullwidth();

            }

            if ( self.grid )
                self.videoWidth();

            else
                self.blog.trigger( 'blogs-loaded' );

            self.catNavSubmenu();

            self.catNavAddParent();

            self.catNavPadding();

        } // end inCallback

        featCallback( self = this )
        {

            let h;

            switch ( self.feat.data( 'count' ) )
            {

                case 2:

                    let art = self.feat.find( 'article' ),
                        hgt = ( h = ( ( art.eq(0).height() + art.eq(1).height() ) / 2 ) < 350 ) ? 350 : h;

                    if ( art.hasClass( 'format-gallery' ) )
                        art.find( 'div.et_pb_slide' ).css( 'height', hgt );

                    break;

                case 3:

                    let right = self.feat.find( 'div.right' ),
                        left  = right.siblings( 'div' ).children( 'article' );

                    h = right.height();

                    self.getElements( left ).css({ 'height': h + 1, 'maxHeight': h + 1 });

                    break;

            } // end switch
        } // end featCallback

        imagesLoaded( img )
        {

            let $i = 0,
                $l = img.length;

            for ( $i; $i < $l; $i++ )
            {

                if ( ! img[$i].complete )
                    return false;

            }

            return true;

        } // end imagesLoaded

        initMediaType( self = this )
        {

            let find  = 'article.ajax-video, article.ajax-gallery, article.ajax-audio',
                items = self.grid
                        ? self.blog.children( 'div' ).children( find )
                        : self.blog.children( find );

            items.each( function()
            {

                if ( $(this).hasClass( 'ajax-video' ) )
                    self.initVideo( $(this).removeClass( 'ajax-video' ) );

                if ( $(this).hasClass( 'ajax-audio' ) )
                    self.initAudio( $(this).removeClass( 'ajax-audio' ) );

                if ( $(this).hasClass( 'ajax-gallery' ) )
                    self.initGallery( $(this).removeClass( 'ajax-gallery' ) );

            });


        } // end initMediaType

        initGallery( el )
        {

            w.et_pb_slider_init( el.find( 'div.et_pb_slider' ) );

        } // end initGallery

        initVideo( el )
        {

            el.find( 'video' ).mediaelementplayer();

        } // end initVideo

        initAudio( el )
        {

            el.find( 'audio' ).mediaelementplayer();

        } // end initAudio

        normalizePosts( input )
        {

            let output = [];

            if ( input.length > 0 )
                input.each( function()
                {

                    output.push( $(this).prop( 'outerHTML' ) );

                });

            return output;

        } // end normalizePosts

        changeContent( self = this )
        {

            let img;

            img = self.imagesToLoad( self.state.content.posts );

            self.changeContent.callback = function()
            {

                let callback, posts, min;

                if ( self.grid )
                {

                    min = self.state.content.posts.length > 0 ? self.minHeight() : 0;

                    self.blog.css( 'minHeight', min ).mosaicflow( 'empty' );

                    for ( let key in self.state.content.posts )
                    {

                        if ( isNaN( parseInt( key ) ) )
                            continue;

                        self.blog.mosaicflow( 'add', $( self.state.content.posts[key] ) );

                    }

                    callback = self.videoWidth;

                }

                if ( self.full )
                {

                    posts = $( self.state.content.posts.join( '' ) );

                    self.blog.css( 'minHeight', self.minHeight() ).html( posts );

                    callback = self.fullwidth;

                }

                self.removeMore( 0 );

                self.adjustChange( self, callback );

            }

            self.interval( img, self.changeContent.callback );

        } // end changeContent

        addGrid( self = this )
        {

            let img, $i = 0,
                maxWd = self.blog.children( 'div.article-col' ).first().width();

            if ( null != self.state.addMore )
            {

                if ( null == self.getSession( 'dfbmAddMore' ) )
                    self.blog.css( 'minHeight', self.minHeight() )
                        .removeClass( 'completed' ).mosaicflow( 'empty' )
                            .parent().removeClass( 'completed' );

                self.state.added = true;

            }

            img = self.imagesToLoad( self.state.content.posts );

            self.addGrid.callback = function()
            {

                for ( let key in self.state.content.posts )
                {

                    let item = $( self.state.content.posts[key] );

                    if ( item.hasClass( 'format-video' ) )
                    {

                        let cont   = item.find( 'video.wp-video-shortcode, iframe' ),
                            width  = cont.prop( 'width' ),
                            height = cont.prop( 'height' ),
                            ratio  = width / height;

                        cont.css({ width : maxWd, height : maxWd / ratio });

                    }

                    self.blog.mosaicflow( 'add', $( item ) );

                    $i++;

                }

                self.adjustAdded();

            }

            self.interval( img, self.addGrid.callback );

            // // with a slightly animation
            // let maxWd   = this.blog.children( 'div.article-col' ).first().width(),
            //     length  = Object.keys( $data.content.posts ).length,
            //     iterate = function()
            //     {

            //         if ( $i < length || ! length )
            //         {

            //             let time = ! $i ? 0 : 200;

            //             setTimeout( function()
            //             {

            //                 if ( length )
            //                 {

            //                     let item = $( $data.content.posts[$i] );

            //                     if ( ! $i ) item.addClass( 'marker' );

            //                     if ( item.hasClass( 'format-video' ) )
            //                     {

            //                         let cont   = item.find( 'video.wp-video-shortcode, iframe' ),
            //                             width  = cont.prop( 'width' ),
            //                             height = cont.prop( 'height' ),
            //                             ratio  = width / height;

            //                         cont.css({ width : maxWd, height : maxWd / ratio });

            //                     }

            //                     $this.blog.mosaicflow( 'add', item );

            //                 }

            //                 if ( ! $i || ! length ) $this.marker( $data.query );

            //                 $i++;

            //                 if ( length ) iterate();

            //             }, time );
            //         }
            //     };

            // if ( ! $i ) iterate();

        } // end addGrid

        addFull( self = this )
        {

            let img;

            if ( null != self.state.addMore )
            {

                if ( null == self.getSession( 'dfbmAddMore' ) )
                    self.blog.css( 'minHeight', self.minHeight() )
                        .removeClass( 'completed' ).empty()
                            .parent().removeClass( 'completed' );

                self.state.added = true;

            }

            img = self.imagesToLoad( self.state.content.posts );

            self.addFull.callback = function()
            {

                let posts = $( self.state.content.posts.join( '' ) )

                self.blog.append( posts );

                self.fullwidth();

                self.adjustAdded();

            }

            self.interval( img, self.addFull.callback );


        } // end addFull

        initAddLayout()
        {

            if ( this.grid )
                this.addGrid();

            else this.addFull();

        } // end initAddLayout

        adjustChange( self = this, callback )
        {

            let push = true;

            callback( false, self );

            self.sharedAdjustment();

            self.pagination();

            if ( self.getSession( 'dfbmRedirect' ) )
                push = false;

            self.changeUrl( self.lCurr, push );

        } // end adjustChange

        adjustAdded()
        {

            this.sharedAdjustment();

            this.marker();

        } // end adjustAdded

        sharedAdjustment()
        {

            this.initMediaType();

            this.query();

            if ( this.lb )
                this.unbind();

            if ( this.shop )
                this.adjustWoo();

            this.removeSession( 'dfbmLoaded' );

// to add for the next update
var inner = $( '#dfbm-container' ).children( '.filterable-blogposts' ).find( 'div.inner' ),
height = Math.max.apply(null, inner.map(function ()
{

    return $(this).innerHeight();

}).get());

inner.css( 'height', height );

        } // end sharedAdjustment

        adjustWoo()
        {

            let bcm = $( 'nav.woocommerce-breadcrumb' ),
                res = $( 'p.woocommerce-result-count' );

            if ( null != this.state.content.breadcrumb && bcm.length > 0 )
                bcm.replaceWith( this.state.content.breadcrumb );

            if ( null != this.state.content.results && res.length > 0 )
                res.replaceWith( this.state.content.results );

        } // end adjustWoo

        pagination()
        {

            let pagination = $( '#dfbm_blog_pagination' );

            if ( pagination.length > 0 )
                pagination.replaceWith( this.state.content.pagination );

            else
                this.parent.append( this.state.content.pagination );

        } // end pagination

        removeMore( time )
        {

            $( '#add-more-button' ).parent()
                .slideUp( time, function()
                {

                    $(this).remove()

                });

        } // end removeMore

        query()
        {

            this.blog.data( 'config', this.state.query );

        } // end query

        ajax( option, attr = {}, self = this )
        {

            let config = self.blog.data( 'config' ),
                atts   = self.blog.data( 'atts' ),
                data   =
                $.extend( {}, attr,
                {

                    nonce  : self.nonce,
                    action : 'dfbm_get_posts',
                    option : option,
                    base   : self.lAjax,
                    query  : config,
                    atts   : atts,

                }
            );

            $.ajax(
            {

                type     : 'post',
                dataType : 'json',
                url      : self.url,
                data      : data,

                success: function( $data )
                {

                    self.state = $data;

                    self.addContentCheck();

                },

                error: function( $data )
                {

                    console.log( $data );

                    location.reload();

                }
            });
        } // end ajax

        addContentCheck()
        {

            switch ( this.state.case )
            {

                case 'category' :

                case 'paged'    :

                    this.changeContent();

                    break;

                case 'more' :

                    this.setMarker();

                    this.initAddLayout();

                    break;
            }
        } // end addContentCheck

        animate( sel, event, data, ajax, self = this )
        {

            let h, t,
                winTop = $( w ).scrollTop(),
                elTop  = sel.offset().top - self.headH - self.cDist - ( 'marker' == event ? 0 : 1 ),
                time   = ( 'marker' == event && null != self.state.addMore && self.state.added )
                           ? 0 : ( t = Math.abs( winTop - elTop ) * 0.2 ) < 500 ? 500 : ( t > 2500 ? 2500 : t );

            $( 'html, body' ).animate(
            {

                scrollTop: elTop

            }, time, 'swing' ).promise().then( function()
            {

                if ( data )
                {

                    if ( event && ajax )
                    {

                        self.setScrollPos( $( w ).scrollTop() );

                        return self.ajax( event, data );

                    }

                    if ( 'marker' == event || null != self.state.addMore )
                    {

                        return self.routeMarker( sel );

                    }

                    self.addContentCheck( data );

                }

                else
                    w.location.reload()

            });
        } // end animate

        animateTarget( event, data, ajax )
        {

            if ( 'category' == event && this.active )
                this.changeActive( data );

            let sel = this.navBar.length > 0 ? this.navBar : this.blog;

            this.animate( sel, event, data, ajax );

        } // end animateTarget

        changeActive( data )
        {

            this.active.fadeOut( 300, function()
            {

                $(this).text( data.name ).fadeIn( 300 );

            });

            this.navBar
                .find( 'a[data-cat-id="' + data.target + '"]').addClass( 'active' )
                    .parent().siblings().find( 'a' ).removeClass( 'active' );

        } // end changeActive

        routeMarker( sel )
        {

            if ( null != this.state.addMore )
            {

                if ( ! this.state.added )
                {

                    return this.initAddLayout();

                }

                this.removeSession( 'dfbmAddMore' );

                if ( ! this.state.content.pagination )
                    this.removeMore( 0 );

                else
                {

                    if ( this.state.content.pagination && $( '#add-more-section' ).length < 1 )
                        this.parent.append( $( this.state.content.pagination ) );

                }

                this.showContent();

                this.state = {};

            }

            if ( sel )
                sel.removeClass( 'marker' );

        } // end routeMarker

        marker()
        {

            let button = true,
                marker = this.blog.find( 'article.marker' );

            if ( marker.length < 1 && null != this.state.scroll )
            {

                this.blog.trigger( 'adjust-scroll-top' );

                this.routeMarker();

            }

            if ( null != this.state.query && this.state.query.paged === this.state.query.maximum_pages )
            {

                button = false;

                this.removeMore( 300 );

            }

            if ( marker.length > 0 )
            {

                this.animate( marker, 'marker', true, false );

            }

            $( '#add-more-button' ).removeClass( 'active' );

            this.changeState( button );

        } // end marker

        setMarker( arr = false, key = 0 )
        {

            let rep = function( $item )
            {

                return $item.replace( 'et_pb_post', 'et_pb_post marker' );

            };

            if ( ! arr )
                return this.state.content.posts[key] = rep( this.state.content.posts[key] );

            return arr[key] = rep( arr[key] );

        } // end setMarker

        deleteMarker( obj )
        {

            let i = obj.state.addMore.index,
                l = obj.state.addMore.posts.length;

            obj.state.addMore.posts[l-i] = obj.state.addMore.posts[l-i].replace( 'et_pb_post marker', 'et_pb_post' );

            return obj;

        } // end deleteMarker

        setScrollPos( pos, link = false )
        {

            let obj = this.getHistoryObj();

            if ( null != obj.state.addMore && null != obj.state.addMore.index )
            {

                if ( obj.state.addMore.index > 0 )
                    obj = this.deleteMarker( obj );

                obj.state.addMore.index = 0;

            }

            obj.state.scroll = pos ? pos : 0;

            this.changeState( false, obj, false, link );

        } // end setScrollPos

        initialState()
        {

            let p, pag = ( p = $( '#dfbm_blog_pagination' ) ).length > 0 ? p : $( '#add-more-section' );

            if ( this.active )
                this.state.case   = 'category';

            else
                this.state.case  = 'paged';

            if ( this.navBar )
            {

                let item = this.navBar.find( '.cat-selector.active');

                this.state.name   = item.data( 'cat-name' );

                this.state.target = item.data( 'cat-id' );

            }

            this.state.query = this.blog.data( 'config' );

            this.state.content = {};

            this.state.content.posts = this.posts;

            if ( pag.length > 0 )
                this.state.content.pagination = pag.prop( 'outerHTML' );

            if ( this.shop )
            {

                let bcm = $( 'nav.woocommerce-breadcrumb' ),
                    res = $( 'p.woocommerce-result-count' );

                if ( bcm.length > 0 )
                    this.state.content.breadcrumb = bcm.prop( 'outerHTML' );

                if ( res.length > 0 )
                    this.state.content.results = res.prop( 'outerHTML' );

            }

        } // end initialState

        changeUrl( link = false, push = false )
        {

            if ( this.noURL )
            {

                let obj = this.getHistoryObj();

                this.noURL = false;

                if ( obj && null != obj.curr && obj.curr != w.location.href )
                    return this.changeState( false, obj, false );

                return;

            }

            if ( this.getSession( 'dfbmRedirect' ) )
            {

                this.blog.trigger( 'adjust-scroll-top' );

                this.showContent();

                return this.changeState( false, false, true );

            }

            let obj = {};

            if ( ! link && ! push )
            {

                this.initialState();

            }

            obj.base   = this.lStart;

            obj.curr   = link ? link : w.location.href;

            obj.state  = ! $.isEmptyObject( this.state ) > 0 ? this.state : false;

            this.state = {};

            if ( this.shop )
                obj.shop = true;

            if ( this.search )
                obj.search = this.getLinkParameter( location.href );

            if ( push )
                return w.history.pushState( JSON.stringify( obj ), '', link );

            this.changeState( false, obj );

        } // end changeUrl

        changeState( but = false, obj = false, redirect, $assign )
        {

            if ( this.noURL )
                return this.noURL = false;

            let link;

            redirect = redirect || this.getSession( 'dfbmRedirect' ) ? true : false;

            if ( ! redirect && ! obj && this.state )
                obj = this.buildAddMoreState( but );

            this.state = {};

            if ( obj || redirect )
            {

                obj = obj ? obj : this.getHistoryObj();

                if ( obj && null != obj.curr )
                    link = obj.curr;

                if ( this.getSession( 'dfbmRedirect' ) )
                {

                    this.removeSession( 'dfbmRedirect' );

                    redirect = false;

                }

                w.history.replaceState( JSON.stringify( obj ), '', link ? link : location.href );

                if ( redirect )
                {

                    this.checkState();

                }

                if ( $assign )
                {

                    w.location.assign( $assign );

                }
            }
        } // end changeState

        checkState( noMerge )
        {

            let obj = this.getHistoryObj();

            if ( obj )
            {

                if ( null == obj.shop && ( obj.base != this.lStart || false === obj.state ) || null != obj.shop && false === obj.state )
                {

                    return null != this.lStart ? this.animateTarget( false, false, false ) : false;

                }

                this.state = obj.state;

                if ( null != this.state.addMore )
                {

                    if ( noMerge && ! this.getSession( 'dfbmRedirect' ) )
                        this.state.content.posts = this.state.addMore.posts;

                    else this.mergeStatePosts();

                }

                this.historyStep();

            }

            else
            {

                this.removeSession( 'dfbmAddMore' );

                w.location.reload();

            }

        } // end checkState

        historyStep()
        {

            if ( ! this.getSession( 'dfbmRedirect' ) )
                this.noURL = true;

            if ( null != this.state.addMore )
                this.state.added = false;

            if ( this.getSession( 'dfbmAddMore' ) )
                return this.initAddLayout();

            this.animateTarget( this.state.case, this.state, false );

        } // end historyStep

        getHistoryObj()
        {

            let h;

            return ! $.isEmptyObject( ( h = w.history.state ) ) ? JSON.parse( h ) : false;

        } // end getHistoryObj

        buildAddMoreState( but )
        {

            let $this = this,
                obj   = this.getHistoryObj();

            if ( null != obj.state.addMore && null != obj.state.addMore.index && obj.state.addMore.index > 0 )
            {

                obj = this.deleteMarker( obj );

            }

            else
            {

                if ( null == obj.state.addMore )
                {

                    obj.state.addMore = {};

                    obj.state.addMore.posts = [];

                }
            }

            if ( null != obj.state.scroll )
                delete obj.state.scroll;

            if ( ! but )
                obj.state.content.pagination = '';

            obj.state.query = this.state.query;

            obj.state.addMore.index = this.state.content.posts.length;

            obj.state.addMore.posts = $.merge( obj.state.addMore.posts, $this.state.content.posts );

            return obj;

        }  // end buildAddMoreState

        mergeStatePosts()
        {

            this.state.content.posts = $.merge( this.state.content.posts, this.state.addMore.posts );

        } // end mergeStatePosts

        getLinkParameter( link )
        {

            return ( -1 !== link.indexOf( '?' ) ) ? link.split( '/' ).filter( i => { return ( -1 !== i.indexOf( '?' ) ) } )[0] : '';

        } // end getLinkParameter

        setSession( key, value )
        {

            w.sessionStorage.setItem( key, value );

        } // end setSession

        getSession( key )
        {

            return w.sessionStorage.getItem( key );

        } // getSession

        removeSession( key )
        {

            w.sessionStorage.removeItem( key );

        } // removeSession

        unbind()
        {

            $( '.et_pb_post .et_pb_video_overlay' ).off();

        } // end unbind

        showContent()
        {

            $( 'html.redirected' ).removeClass( 'redirected' );

            this.blog.addClass( 'completed' ).parent().addClass( 'completed' );

        } // end showContent

        bindEvents( self = this )
        {

            self.blog
                .one( 'adjust-scroll-top', function()
                {

                    let obj = self.getHistoryObj();

                    if ( obj && null != obj.state && null != obj.state.scroll )
                    {

                        $( w ).scrollTop( obj.state.scroll );

                        $( 'html.redirected' ).removeClass( 'redirected' );

                    }

                })
                .one( 'mosaicflow-filled blogs-loaded', function( e )
                {

                    if ( ! self.getSession( 'dfbmAddMore' ) && ! sessionStorage.getItem( 'dfbmRedirect' ) )
                    {

                        if ( 'blogs-loaded' == e.type )
                            self.showContent();

                        if ( self.lb )
                            self.unbind();

                        self.removeSession( 'dfbmLoaded' );

                        if ( ! self.getHistoryObj() )
                            self.changeUrl( false, false );

                    }

                    else
                    {

                        if ( self.grid && self.getSession( 'dfbmAddMore' ) )
                            self.blog.find( 'article' ).css(
                            {

                                position   : 'static',
                                visibility : 'visible',
                                display    : 'block',

                            });

                        self.checkState( true );

                    }

                });

            self.parent
                .on( 'mouseenter', '.content-overlay article.hover', function()
                {

                    $(this).find( 'div.header-before' ).slideDown( 300 );

                })
                .on( 'mouseleave', 'div.content-overlay article.hover', function()
                {

                    $(this).find( 'div.header-before' ).finish().slideUp( 300 );

                })
                .on( 'click', 'div.et_pb_content_container.click', function()
                {

                    $(this).addClass( 'clicked hover' ).removeClass( 'click' )
                        .find( 'div.header-before' ).slideDown( 300 );

                })
                .on( 'click', 'div.et_pb_content_container.clicked', function()
                {

                    $(this).addClass( 'click' ).removeClass( 'clicked hover' )
                        .find( 'div.header-before' ).finish().slideUp( 300 );

                })
                .on( 'click', '.entry-title a, a.et_pb_button.read-more, a.no-lb', function( e )
                {

                    e.stopPropagation();

                    e.preventDefault();

                    self.setScrollPos( $( w ).scrollTop(), $(this).prop( 'href' ) );

                })
                .on( 'click', 'div.clicked a.add_to_cart_button', function( e )
                {

                    e.preventDefault();

                    $(this).trigger( 'click' );

                })
                .on( 'click', 'div.clicked a.wc-forward', function( e )
                {

                    e.stopPropagation();

                })
                .on( 'click', 'a.cat-selector', function( e )
                {

                    if ( ( self.search && ! self.shop ) || self.author )
                        return;

                    e.preventDefault();

                    if ( self.width < 768 && $(this).parent().hasClass( 'parent' ) && ! $(this).parent().hasClass( 'opened' ) )
                        return $(this).parent().addClass( 'opened' );

                    let not, param, category = {};

                    param = self.getLinkParameter( location.href );

                    if ( -1 !== param.indexOf( '&s=' ) )
                    {

                        param = param.split( '&' ).filter( function( i )
                        {

                            return ( -1 === i.indexOf( 's=' ) );

                        }).join( '&' );

                    }

                    self.lCurr = self.lBase = $(this).prop( 'href' ) + param;

                    self.lAjax = self.lBase.split( '?' )[0] + param;

                    category.target = $(this).data( 'cat-id' );

                    category.name   = $(this).data( 'cat-name' );

                    if ( ( not = self.blog.data( 'cat-not-id' ) ) )
                        category.targetNot = not;

                    self.navBar.children( 'li.parent' ).removeClass( 'opened' );

                    self.animateTarget( 'category', category, true );

                })
                .on( 'click', 'a.page-numbers', function( e )
                {

                    e.preventDefault();

                    let targ, param, page = {},
                        link = $(this).prop( 'href' );

                    self.lCurr = link;

                    param = self.getLinkParameter( link );

                    if ( param )
                        link = link.replace( param, '' );

                    self.lAjax = self.lBase + param;

                    targ = ( link.split( '/' )
                               .filter( i => { return i !== '' } ) )
                                   .slice( -1 );

                    page.target = isNaN( ( targ = parseInt( targ ) ) ) ? 1 : targ;

                    self.animateTarget( 'paged', page, true );

                })
                .on( 'click', '#add-more-button', function( e )
                {

                    if ( $(this).hasClass( 'active' ) )
                        return;

                    e.preventDefault();

                    $(this).addClass( 'active' );

                    self.ajax( 'more' );

                })
                .on( 'click', 'a.et_pb_video_play, div.et_pb_video_overlay', function( e )
                {

                    e.preventDefault();

                    e.stopImmediatePropagation();

                    let play = $(this).hasClass( 'et_pb_video_overlay' )
                               ? $(this) : $(this).closest( 'div.et_pb_video_overlay' );

                    w.et_pb_play_overlayed_video( play );

                }); // end this.parent

            self.navBar.on( 'mouseenter', 'li.parent', function()
            {

                if ( self.width < 768 )
                {

                    if ( $(this).hasClass( 'opened' ) )
                    {

                        $(this).removeClass( 'opened' )
                            .children( 'ul.first' ).fadeOut( 400 );

                    }

                    else
                    {

                        $(this).addClass( 'opened' )
                            .children( 'ul.first' ).fadeIn( 400 );

                    }
                }
            });

            $( document )
                .on( 'click', 'a.dfbm-lb-link, a.dfbm-lb-read-more', function( e )
                {

                    e.preventDefault();

                    let pos = self.getSession( 'dfbmScrollPos' );

                    self.removeSession( 'dfbmScrollPos' );

                    self.setScrollPos( pos, $(this).prop( 'href' ) );

                });

            $( w )
                .on( 'resize', function()
                {

                    self.catNavSubmenu();

                    self.width = $( w ).width();

                    self.catNavPadding();

                    self.headH = self.header();

                    if ( self.width > 767 )
                        self.featured();

                    if ( self.grid )
                        self.videoWidth( true );

                    else
                        self.fullwidth();

                })
                .on( 'popstate', function()
                {

                    if ( self.getSession( 'dfbmRedirect' ) || self.getSession( 'dfbmAddMore' ) )
                    {

                        let noRedirect = setInterval( function()
                        {

                            if ( ! self.getSession( 'dfbmRedirect' ) && ! self.getSession( 'dfbmAddMore' ) )
                            {

                                clearInterval( noRedirect );

                                self.checkState();

                            }
                        }, 100 );
                    }

                    else
                        self.checkState();

                });

        } // end bindEvents
    } // end dfbmBlogthread

    new dfbmBlogthread;

});}(jQuery,window));
